// @ts-nocheck
import type { Locale } from '@skytech/types'

type DayJSLocale = 'en' | 'ru' | 'nl' | 'fr' | 'es' | 'en-gb' | 'da' | 'se' | 'nb' | 'de' | 'fi'

export const mapInternalLocaleToDayjs = (locale: Locale): DayJSLocale => {
  switch (locale) {
    case 'en': {
      import('dayjs/locale/en.js')
      return 'en'
    }
    case 'nl': {
      import('dayjs/locale/nl.js')
      return 'nl'
    }
    case 'fr': {
      import('dayjs/locale/fr.js')
      return 'fr'
    }
    case 'es': {
      import('dayjs/locale/es.js')
      return 'es'
    }
    case 'gb': {
      import('dayjs/locale/en-gb.js')
      return 'en-gb'
    }
    case 'dk': {
      import('dayjs/locale/da.js')
      return 'da'
    }
    case 'se': {
      import('dayjs/locale/se.js')
      return 'se'
    }
    case 'no': {
      import('dayjs/locale/nb.js')
      return 'nb'
    }
    case 'de': {
      import('dayjs/locale/de.js')
      return 'de'
    }
    case 'fi': {
      import('dayjs/locale/fi.js')
      return 'fi'
    }
    // Philippine not available at the moment
    case 'ph': {
      import('dayjs/locale/en.js')
      return 'en'
    }

    default:
      return 'en'
  }
}
